import store from "./store/index.mjs";
export default {
  store
};
//# sourceMappingURL=index.mjs.map